import domService from './dom.service';

const standardMeta = domService.getMetaViewport();
const unscalableMeta = standardMeta + ', maximum-scale=1.0, user-scalable=0';
const timeout = 2000;

let blurTimer;

const prohibitZoomDirective = {
    beforeMount(el: HTMLElement) {
        el.ontouchstart = touchstartHandler;
        el.onfocus = focusHandler;
        el.onblur = blurHandler;

        function touchstartHandler() {
            clearTimeout(blurTimer);
            domService.setMetaViewport(unscalableMeta);
        }

        function focusHandler() {
            clearTimeout(blurTimer);
            domService.setMetaViewport(unscalableMeta);
        }

        function blurHandler() {
            clearTimeout(blurTimer);
            blurTimer = setTimeout(() => {
                domService.setMetaViewport(standardMeta);
            }, timeout);
        }
    },
};

export default prohibitZoomDirective;
